var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.277692 1.02132C-0.104252 1.42024 -0.0904913 2.05326 0.308429 2.4352L4.55402 6.50013L0.308429 10.5651C-0.0904913 10.947 -0.104252 11.58 0.277692 11.9789C0.659636 12.3779 1.29265 12.3916 1.69157 12.0097L6.69157 7.22243C6.88859 7.0338 7 6.77288 7 6.50013C7 6.22737 6.88859 5.96645 6.69157 5.77782L1.69157 0.990584C1.29265 0.60864 0.659636 0.622401 0.277692 1.02132Z","fill":"white"}));
}

Arrow.defaultProps = {"width":"7","height":"13","viewBox":"0 0 7 13","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
